const HANDLE_FITTING_VARIANT_ID = '62473639494003';
const ENGRAVING_VARIANT_ID = '62473639887219';
const CUSTOM_BOX_VARIANT_ID = '62488262672755';

function extractVariantId(gid) {
    if (!gid) return null;
    if (typeof gid === 'number') return gid;
    if (typeof gid === 'string' && !gid.includes('gid://')) return gid;
    const match = gid.match(/ProductVariant\/(\d+)/);
    return match ? match[1] : gid;
}

async function getNextCustomOrderNumber() {
    try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        
        let highestNumber = 0;
        
        if (cart.items && cart.items.length > 0) {
            cart.items.forEach(function(item) {
                if (item.properties && item.properties['Custom Order']) {
                    const orderNum = parseInt(item.properties['Custom Order'], 10);
                    if (!isNaN(orderNum) && orderNum > highestNumber) {
                        highestNumber = orderNum;
                    }
                }
            });
        }
        
        return highestNumber + 1;
    } catch (error) {
        console.error('Error fetching cart for order number:', error);
        return 1;
    }
}

function AddToCartButton() {
    const [totalPrice, setTotalPrice] = React.useState(0);
    const [discountedPrice, setDiscountedPrice] = React.useState(0);
    const [discountPercent, setDiscountPercent] = React.useState(0);
    const [quantity, setQuantity] = React.useState(null);
    const [isLoading, setIsLoading] = React.useState(false);
    const [bladeData, setBladeData] = React.useState(null);
    const [handleData, setHandleData] = React.useState(null);
    const [selectedShape, setSelectedShape] = React.useState(null);

    const formatPrice = (price) => {
        if (window.CurrencyFormat && window.CurrencyFormat.formatMoney) {
            return window.CurrencyFormat.formatMoney(price || 0);
        }
        return '¥' + (price || 0).toLocaleString() + ' JPY';
    };
    
    React.useEffect(() => {
        const checkState = setInterval(() => {
            if (typeof window.KnifeCustomizationState === 'undefined') return;
            
            const newBladeData = window.KnifeCustomizationState.selectedBladeData;
            const newHandleData = window.KnifeCustomizationState.selectedHandleData;
            const newShape = window.KnifeCustomizationState.selectedShape;
            
            if (newBladeData !== bladeData) {
                setBladeData(newBladeData);
            }
            if (newHandleData !== handleData) {
                setHandleData(newHandleData);
            }
            if (newShape !== selectedShape) {
                setSelectedShape(newShape);
            }
            
            let unitPrice = 0;
            
            if (newBladeData && newBladeData.price) {
                unitPrice += newBladeData.price;
            }
            
            if (newHandleData && newHandleData.price) {
                unitPrice += newHandleData.price;
            }
            
            if (window.KnifeCustomizationState.handleFittingPrice) {
                unitPrice += window.KnifeCustomizationState.handleFittingPrice;
            }
            
            if (window.KnifeCustomizationState.engravingPrice) {
                unitPrice += window.KnifeCustomizationState.engravingPrice;
            }
            
            const currentQuantity = window.KnifeCustomizationState.quantity;
            const currentDiscount = window.KnifeCustomizationState.discountPercent ?? 0;
            
            if (currentQuantity !== quantity) {
                setQuantity(currentQuantity);
            }
            
            if (currentDiscount !== discountPercent) {
                setDiscountPercent(currentDiscount);
            }
            
            if (currentQuantity && currentQuantity > 0) {
                let newTotal = unitPrice * currentQuantity;
                
                // Add custom box price (one-time charge, not multiplied by quantity)
                if (window.KnifeCustomizationState.customBoxPrice) {
                    newTotal += window.KnifeCustomizationState.customBoxPrice;
                }
                
                const newDiscountedTotal = newTotal * (1 - currentDiscount / 100);
                
                if (newTotal !== totalPrice) {
                    setTotalPrice(newTotal);
                }
                
                if (newDiscountedTotal !== discountedPrice) {
                    setDiscountedPrice(newDiscountedTotal);
                }
            } else {
                if (totalPrice !== 0) setTotalPrice(0);
                if (discountedPrice !== 0) setDiscountedPrice(0);
            }
        }, 100);
        
        return () => clearInterval(checkState);
    }, [totalPrice, discountedPrice, discountPercent, quantity, bladeData, handleData, selectedShape]);
    
    const handleAddToCart = async () => {
        if (typeof window.KnifeCustomizationState === 'undefined') return;
        
        const currentQuantity = window.KnifeCustomizationState.quantity;
        
        if (!currentQuantity || currentQuantity < 1) {
            alert('Please select a quantity before adding to cart.');
            return;
        }
        
        const currentBladeData = window.KnifeCustomizationState.selectedBladeData;
        const currentHandleData = window.KnifeCustomizationState.selectedHandleData;
        const currentShape = window.KnifeCustomizationState.selectedShape;
        
        const hasBlade = currentBladeData && currentBladeData.variantId;
        const hasHandle = currentHandleData && currentHandleData.variantId;
        
        if (!hasBlade && !hasHandle) {
            alert('Please select at least a blade or handle before adding to cart.');
            return;
        }
        
        // Validate engraving options if engraving is enabled
        if (hasBlade && window.KnifeCustomizationState.engravingRequired === 'yes') {
            const hasEngravingLocation = window.KnifeCustomizationState.engravingLocation;
            const hasEngravingFile = window.KnifeCustomizationState.engravingImage;
            
            if (!hasEngravingLocation && !hasEngravingFile) {
                alert('Please select an engraving location and upload your logo file.');
                return;
            }
            if (!hasEngravingLocation) {
                alert('Please select an engraving location.');
                return;
            }
            if (!hasEngravingFile) {
                alert('Please upload your logo file for engraving.');
                return;
            }
        }
        
        // Validate custom box options if custom box is enabled
        if (window.KnifeCustomizationState.customBoxRequired === 'yes') {
            const hasBoxColor = window.KnifeCustomizationState.customBoxColor;
            const hasBoxFile = window.KnifeCustomizationState.customBoxImage;
            
            if (!hasBoxColor && !hasBoxFile) {
                alert('Please select a box color and upload your logo file for the custom knife box.');
                return;
            }
            if (!hasBoxColor) {
                alert('Please select a box color for the custom knife box.');
                return;
            }
            if (!hasBoxFile) {
                alert('Please upload your logo file for the custom knife box.');
                return;
            }
        }
        
        setIsLoading(true);
        
        try {
            const items = [];
            const orderTimestamp = Date.now();
            const customOrderNumber = await getNextCustomOrderNumber();
            
            if (hasBlade) {
                const bladeVariantId = extractVariantId(currentBladeData.variantId);
                if (!bladeVariantId) {
                    throw new Error('Could not process blade product ID. Please try again.');
                }
                
                items.push({
                    id: bladeVariantId,
                    quantity: currentQuantity,
                    properties: {
                        'Custom Order': customOrderNumber.toString(),
                        '_customization_order': orderTimestamp.toString(),
                        '_knife_shape': currentShape || 'N/A',
                        '_customization_type': 'blade'
                    }
                });
            }
            
            if (hasHandle) {
                const handleVariantId = extractVariantId(currentHandleData.variantId);
                if (!handleVariantId) {
                    throw new Error('Could not process handle product ID. Please try again.');
                }
                
                items.push({
                    id: handleVariantId,
                    quantity: currentQuantity,
                    properties: {
                        'Custom Order': customOrderNumber.toString(),
                        '_customization_order': orderTimestamp.toString(),
                        '_knife_shape': currentShape || 'N/A',
                        '_customization_type': 'handle'
                    }
                });
            }
            
            if (hasBlade && hasHandle && window.KnifeCustomizationState.handleFittingRequired === 'yes') {
                items.push({
                    id: HANDLE_FITTING_VARIANT_ID,
                    quantity: currentQuantity,
                    properties: {
                        'Custom Order': customOrderNumber.toString(),
                        '_customization_order': orderTimestamp.toString(),
                        '_knife_shape': currentShape || 'N/A',
                        '_service_type': 'handle-fitting',
                        'Blade': currentBladeData.name || 'N/A',
                        'Handle': currentHandleData.name || 'N/A'
                    }
                });
            }
            
            if (hasBlade && window.KnifeCustomizationState.engravingRequired === 'yes') {
                const engravingProperties = {
                    'Custom Order': customOrderNumber.toString(),
                    '_customization_order': orderTimestamp.toString(),
                    '_knife_shape': currentShape || 'N/A',
                    '_service_type': 'engraving',
                    'Blade': currentBladeData.name || 'N/A',
                    'Location': window.KnifeCustomizationState.engravingLocation || 'Not specified'
                };
                
                const uploadedFile = window.KnifeCustomizationState.engravingImage;
                if (uploadedFile && uploadedFile.cloudinaryUrl) {
                    engravingProperties['Logo File'] = uploadedFile.cloudinaryUrl;
                } else if (uploadedFile && uploadedFile.name) {
                    engravingProperties['Logo Filename'] = uploadedFile.name;
                }
                
                items.push({
                    id: ENGRAVING_VARIANT_ID,
                    quantity: currentQuantity,
                    properties: engravingProperties
                });
            }
            
            // Add Custom Knife Box (quantity: 1, one-time charge)
            if (window.KnifeCustomizationState.customBoxRequired === 'yes') {
                const customBoxProperties = {
                    'Custom Order': customOrderNumber.toString(),
                    '_customization_order': orderTimestamp.toString(),
                    '_knife_shape': currentShape || 'N/A',
                    '_service_type': 'custom-box',
                    'Box Color': window.KnifeCustomizationState.customBoxColor || 'Not specified'
                };
                
                const boxFile = window.KnifeCustomizationState.customBoxImage;
                if (boxFile && boxFile.cloudinaryUrl) {
                    customBoxProperties['Logo File'] = boxFile.cloudinaryUrl;
                } else if (boxFile && boxFile.name) {
                    customBoxProperties['Logo Filename'] = boxFile.name;
                }
                
                items.push({
                    id: CUSTOM_BOX_VARIANT_ID,
                    quantity: 1,  // One-time charge, not per knife
                    properties: customBoxProperties
                });
            }
            
            console.log('Adding to cart:', items);
            
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ items })
            });
            
            const result = await response.json();
            
            if (result.status === 422 || result.status === 404) {
                throw new Error(result.description || 'Failed to add to cart');
            }
            
            console.log('Added to cart:', result);
            
            const cartCheck = await fetch('/cart.js');
            const cartData = await cartCheck.json();
            
            if (cartData.item_count === 0) {
                console.error('Cart is empty after add - retrying');
                throw new Error('Cart did not update. Please try again.');
            }
            
            console.log('Cart verified:', cartData.item_count, 'items');
            
            window.location.href = '/cart';
            
        } catch (error) {
            console.error('Error adding to cart:', error);
            alert(error.message || 'Failed to add to cart. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    const hasDiscount = discountPercent > 0 && quantity;
    const displayPrice = hasDiscount ? discountedPrice : totalPrice;
    
    return React.createElement('div', {
        className: 'summary--buy-button',
        onClick: isLoading ? null : handleAddToCart,
        style: { 
            cursor: isLoading ? 'not-allowed' : 'pointer',
            opacity: isLoading ? 0.7 : 1
        }
    },
        React.createElement('div', { className: 'summary--buy-text' }, 
            isLoading ? 'ADDING...' : 'ADD TO CART - '
        ),
        !isLoading && React.createElement('div', { className: 'summary--buy-price' }, 
            formatPrice(displayPrice) + (hasDiscount ? ' (' + discountPercent + '% off)' : '')
        )
    );
}

window.AddToCartButton = AddToCartButton;